(() => {
  const key = '__tnmShopNavigation';
  if (window[key]) return;

  const selector = 'details[data-tnm-shop-menu]';
  const menus = () => [...document.querySelectorAll(selector)];
  const accounts = () => [...document.querySelectorAll('[data-account-menu]')];
  const accountIsOpen = account => {
    const panel = account.querySelector('[data-account-menu-panel]');
    return panel && !panel.classList.contains('hidden');
  };
  const closeAccount = (account, restoreFocus = false) => {
    if (!accountIsOpen(account)) return;
    account.querySelector('[data-account-menu-panel]').classList.add('hidden');
    const button = account.querySelector('[data-account-menu-button]');
    button?.setAttribute('aria-expanded', 'false');
    if (restoreFocus) button?.focus();
  };
  const closeAccounts = except => accounts().forEach(account => {
    if (account !== except) closeAccount(account);
  });
  const mobileDrawer = () => document.querySelector('[data-tnm-mobile-menu]');
  const mobileIsOpen = () => {
    const drawer = mobileDrawer();
    return drawer && !drawer.classList.contains('hidden');
  };
  const availableHeight = element => {
    const viewport = window.visualViewport;
    const viewportBottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
    return Math.max(0, Math.floor(viewportBottom - element.getBoundingClientRect().top - 12));
  };
  const updatePanelHeight = menu => {
    const panel = menu.querySelector('.tnm-shop-menu__panel');
    if (!menu.open || !panel) return;
    panel.style.setProperty('--tnm-shop-available-height', `${availableHeight(panel)}px`);
  };
  const updateMobileHeight = () => {
    if (!mobileIsOpen()) return;
    const drawer = mobileDrawer();
    drawer.style.setProperty('max-height', `${availableHeight(drawer)}px`);
  };
  let measureFrame = null;
  const updateOpenPanelHeights = () => {
    if (measureFrame !== null || (!menus().some(menu => menu.open) && !mobileIsOpen())) return;
    measureFrame = window.requestAnimationFrame(() => {
      measureFrame = null;
      menus().filter(menu => menu.open).forEach(updatePanelHeight);
      updateMobileHeight();
    });
  };
  const close = (menu, restoreFocus = false) => {
    if (!menu.open) return;
    menu.open = false;
    if (restoreFocus) menu.querySelector('summary')?.focus();
  };
  const closeAll = (except) => menus().forEach(menu => {
    if (menu !== except) close(menu);
  });

  const closeMobileDrawer = (restoreFocus = false) => {
    const drawer = mobileDrawer();
    const toggle = document.querySelector('[data-tnm-mobile-toggle]');
    if (!drawer || !toggle) return false;
    const wasOpen = !drawer.classList.contains('hidden');
    drawer.classList.add('hidden');
    drawer.style.removeProperty('max-height');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.querySelector('[data-icon-menu]')?.classList.remove('hidden');
    toggle.querySelector('[data-icon-close]')?.classList.add('hidden');
    if (restoreFocus && wasOpen) toggle.focus();
    return wasOpen;
  };

  document.addEventListener('toggle', event => {
    const menu = event.target;
    if (menu.matches?.(selector) && menu.open) {
      closeAll(menu);
      closeAccounts();
      updatePanelHeight(menu);
    }
  }, true);

  document.addEventListener('click', event => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (target.closest('dialog[open]')) return;
    closeAccounts(target.closest('[data-account-menu]'));
    if (target.closest('[data-tnm-mobile-toggle]')) {
      window.setTimeout(updateMobileHeight, 0);
    } else if (mobileIsOpen() && !mobileDrawer().contains(target)) {
      closeMobileDrawer(mobileDrawer().contains(document.activeElement));
    }
    const containingMenu = target.closest(selector);
    if (containingMenu) {
      if (target.closest('[data-tnm-shop-close]')) {
        event.preventDefault();
        close(containingMenu, true);
        return;
      }
      if (target.closest('a[href]')) window.setTimeout(() => close(containingMenu), 0);
      return;
    }
    closeAll();
  }, true);

  document.addEventListener('keydown', event => {
    if (event.defaultPrevented) return;
    if (event.key === 'ArrowDown' && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey) {
      const summary = event.target.closest?.('summary');
      const containingMenu = summary?.parentElement;
      if (containingMenu?.matches(selector)) {
        event.preventDefault();
        closeAll(containingMenu);
        closeAccounts();
        containingMenu.open = true;
        updatePanelHeight(containingMenu);
        containingMenu.querySelector('.tnm-shop-menu__panel a[href]')?.focus();
      }
      return;
    }
    if (event.key !== 'Escape') return;
    if (event.target.closest?.('dialog[open]') || document.activeElement?.closest('dialog[open]')) return;
    const menu = menus().find(item => item.open && item.contains(document.activeElement)) || menus().find(item => item.open);
    if (menu) {
      event.preventDefault();
      close(menu, true);
      return;
    }
    const account = accounts().find(item => accountIsOpen(item) && item.contains(document.activeElement)) || accounts().find(accountIsOpen);
    if (account) {
      event.preventDefault();
      closeAccount(account, true);
      return;
    }
    if (closeMobileDrawer(true)) event.preventDefault();
  });

  let pointerRegions = [];
  document.addEventListener('pointerdown', event => {
    pointerRegions = [selector, '[data-account-menu]', '[data-tnm-mobile-menu]']
      .map(region => event.target.closest?.(region)).filter(Boolean);
    // Let the header click toggle the drawer before focus leaving it can close it.
    if (event.target.closest?.('[data-tnm-mobile-toggle]')) {
      const drawer = mobileDrawer();
      if (drawer) pointerRegions.push(drawer);
    }
  }, true);
  const endPointer = () => { window.setTimeout(() => { pointerRegions = []; }, 0); };
  document.addEventListener('pointerup', endPointer, true);
  document.addEventListener('pointercancel', endPointer, true);

  const handleFocusExit = (region, event, onExit) => {
    if (pointerRegions.includes(region)) return;
    if (event.relatedTarget instanceof Node) {
      if (!region.contains(event.relatedTarget) && !event.relatedTarget.closest?.('dialog[open]')) onExit();
      return;
    }
    window.setTimeout(() => {
      if (!region.contains(document.activeElement) && !document.activeElement?.closest('dialog[open]')) onExit();
    }, 0);
  };
  document.addEventListener('focusout', event => {
    const menu = event.target.closest?.(selector);
    if (menu?.open) handleFocusExit(menu, event, () => close(menu));
    const account = event.target.closest?.('[data-account-menu]');
    if (account && accountIsOpen(account)) handleFocusExit(account, event, () => closeAccount(account));
    const drawer = event.target.closest?.('[data-tnm-mobile-menu]');
    if (drawer && mobileIsOpen()) handleFocusExit(drawer, event, () => closeMobileDrawer());
  });

  const breakpoint = window.matchMedia('(min-width: 1280px)');
  breakpoint.addEventListener('change', () => {
    closeAll();
    closeAccounts();
    if (breakpoint.matches) closeMobileDrawer();
  });
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll?.(selector).forEach(menu => close(menu));
  });

  window.addEventListener('resize', updateOpenPanelHeights, {passive: true});
  window.addEventListener('scroll', updateOpenPanelHeights, {passive: true});
  window.visualViewport?.addEventListener('resize', updateOpenPanelHeights, {passive: true});
  window.visualViewport?.addEventListener('scroll', updateOpenPanelHeights, {passive: true});
  document.addEventListener('transitionend', event => {
    if (event.target.closest?.('[data-tnm-header]')) updateOpenPanelHeights();
  });

  window[key] = {closeAll};
})();
